import { render, staticRenderFns } from "./CardDragger.vue?vue&type=template&id=74d20d86&scoped=true&"
import script from "./CardDragger.vue?vue&type=script&lang=js&"
export * from "./CardDragger.vue?vue&type=script&lang=js&"
import style0 from "./CardDragger.vue?vue&type=style&index=0&id=74d20d86&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74d20d86",
  null
  
)

export default component.exports